import { render } from "./SponsorsHome.vue?vue&type=template&id=9cda4704"
import script from "./SponsorsHome.vue?vue&type=script&lang=js"
export * from "./SponsorsHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benme\\Documents\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__